import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CompanyPlaceholderIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 25 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
            d="M5.75.25h12.5v9.269l5 2.294V22.25h1v1.5H.75v-1.5h1V8.505l4-1.714V.25Zm4.5 22h6.5V20H14v1.25h-1.5V18.5h4.25v-2.75H14V17h-1.5v-2.75h4.25V11.5H14v1.25h-1.5V10h4.25V7.25H14V8.5h-1.5V5.75h4.25v-4h-9.5v4.398l3-1.285V22.25Zm8 0V11.17l3.5 1.605v9.475h-3.5Zm-15-2.75V18h5.5v1.5h-5.5Zm0-6V12h5.5v1.5h-5.5Zm5.5-3h-5.5V9.495l5.5-2.358V10.5ZM3.25 15v1.5h5.5V15h-5.5Zm0 6v1.25h5.5V21h-5.5Z"/>
    </svg>
);
CompanyPlaceholderIcon.displayName = 'CompanyPlaceholderIcon';
export default CompanyPlaceholderIcon;
